import src from "IMAGE";
export default { src, width: 354, height: 48, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR42mOoU9fqceHhc/Xm4fNQY2MPZWBgcANiGyB2B2InAFpTBD8tKNnxAAAAAElFTkSuQmCC"};
